import { NgModule } from '@angular/core';
import { AppAvatarPipe } from './app-avatar.pipe';

@NgModule({
  declarations: [AppAvatarPipe],
  exports: [AppAvatarPipe]
})
export class AppAvatarPipeModule {}
